module.exports = __webpack_public_path__ + "static/img/video3.536a790.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/documentPhonePage/video3.png
// module id = Ls66
// module chunks = 0